import { render, staticRenderFns } from "./LinkToRequestAlert.vue?vue&type=template&id=4cbfd7da&"
import script from "./LinkToRequestAlert.vue?vue&type=script&lang=js&"
export * from "./LinkToRequestAlert.vue?vue&type=script&lang=js&"
import style0 from "./LinkToRequestAlert.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports